import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { toBoolean } from '../util/convert';
import { measureScrollbar } from '../util/mesureScrollBar';
import { NzThDirective } from './nz-th.directive';

@Component({
  selector     : 'nz-table',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <div
      class="ant-table-wrapper"
      [class.ant-table-empty]="data.length==0">
      <nz-spin [nzSpinning]="nzLoading">
        <div>
          <div
            class="ant-table"
            [class.ant-table-fixed-header]="nzScroll"
            [class.ant-table-scroll-position-left]="nzScroll"
            [class.ant-table-bordered]="nzBordered"
            [class.ant-table-large]="(nzSize!=='middle')&&(nzSize!=='small')"
            [class.ant-table-middle]="nzSize=='middle'"
            [class.ant-table-small]="nzSize=='small'">
            <div class="ant-table-title" *ngIf="nzShowTitle">
              <ng-content select="[nz-table-title]"></ng-content>
            </div>
            <div class="ant-table-content">
              <div [class.ant-table-scroll]="nzScroll">
                <div class="ant-table-header" [ngStyle]="_headerBottomStyle" *ngIf="nzScroll">
                  <table>
                    <colgroup>
                      <col *ngFor="let th of ths" [style.width]="th.nzWidth" [style.minWidth]="th.nzWidth">
                    </colgroup>
                    <ng-template [ngTemplateOutlet]="fixedHeader"></ng-template>
                  </table>
                </div>
                <div class="ant-table-body" [style.maxHeight.px]="nzScroll?.y" [style.overflowY]="nzScroll?.y?'scroll':''">
                  <table>
                    <colgroup>
                      <col [style.width]="th.nzWidth" [style.minWidth]="th.nzWidth" *ngFor="let th of ths">
                    </colgroup>
                    <ng-content></ng-content>
                  </table>
                </div>
                <div class="ant-table-placeholder" *ngIf="data.length==0 && !nzCustomNoResult">
                  <span>{{ 'Table.emptyText' | nzTranslate }}</span>
                </div>
                <div class="ant-table-placeholder" *ngIf="data.length==0 && nzCustomNoResult">
                  <ng-content select="[noResult]"></ng-content>
                </div>
                <div class="ant-table-footer" *ngIf="nzShowFooter">
                  <ng-content select="[nz-table-footer]"></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nz-pagination
          *ngIf="nzIsPagination&&data.length"
          class="ant-table-pagination"
          [nzShowSizeChanger]="nzShowSizeChanger"
          [nzPageSizeSelectorValues]="nzPageSizeSelectorValues"
          [nzShowQuickJumper]="nzShowQuickJumper"
          [nzShowTotal]="nzShowTotal"
          [nzSize]="(nzSize=='middle'||nzSize=='small')?'small':''"
          [(nzPageSize)]="nzPageSize"
          [nzTotal]="nzTotal"
          [(nzPageIndex)]="nzPageIndex"
          (nzPageIndexClickChange)="pageChangeClick($event)">
        </nz-pagination>
      </nz-spin>
    </div>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-table-wrapper {
  zoom: 1;
}
.ant-table-wrapper:before,
.ant-table-wrapper:after {
  content: " ";
  display: table;
}
.ant-table-wrapper:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-table {
  font-size: 14px;
  color: #666;
  overflow: hidden;
  position: relative;
  border-radius: 4px 4px 0 0;
  /* fix firefox scrollbar bug */
}
.ant-table-body {
  transition: opacity 0.3s ease;
}
.ant-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-thead > tr > th {
  background: #f7f7f7;
  font-weight: 500;
  transition: background .3s ease;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
}
.ant-table-thead > tr > th[colspan] {
  text-align: center;
}
.ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  position: relative;
  margin-left: 4px;
  font-size: 14px;
  cursor: pointer;
  color: #aaa;
  transition: all .3s;
  width: 14px;
}
.ant-table-thead > tr > th .anticon-filter:hover,
.ant-table-thead > tr > th .ant-table-filter-icon:hover {
  color: #666;
}
.ant-table-thead > tr > th .anticon-filter:after,
.ant-table-thead > tr > th .ant-table-filter-icon:after {
  content: '';
  position: absolute;
  width: 14px;
  height: 50px;
  left: 0;
  top: -19px;
}
.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {
  color: #00b8a9;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e9e9e9;
  transition: all .3s;
}
.ant-table-thead > tr,
.ant-table-tbody > tr {
  transition: all .3s;
}
.ant-table-thead > tr.ant-table-row-hover > td,
.ant-table-tbody > tr.ant-table-row-hover > td,
.ant-table-thead > tr:hover > td,
.ant-table-tbody > tr:hover > td {
  background: #ebf9f8;
}
.ant-table-thead > tr:hover {
  background: none;
}
.ant-table-footer {
  padding: 16px 8px;
  background: #f7f7f7;
  border-radius: 0 0 4px 4px;
  position: relative;
}
.ant-table-footer:before {
  content: '';
  height: 1px;
  background: #f7f7f7;
  position: absolute;
  top: -1px;
  width: 100%;
  left: 0;
}
.ant-table.ant-table-bordered .ant-table-footer {
  border: 1px solid #e9e9e9;
}
.ant-table-title {
  padding: 16px 0;
  position: relative;
  top: 1px;
  border-radius: 4px 4px 0 0;
}
.ant-table.ant-table-bordered .ant-table-title {
  border: 1px solid #e9e9e9;
  padding-left: 8px;
  padding-right: 8px;
}
.ant-table-title + .ant-table-content {
  position: relative;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-bordered .ant-table-title + .ant-table-content,
.ant-table-bordered .ant-table-title + .ant-table-content table {
  border-radius: 0;
}
.ant-table-without-column-header .ant-table-title + .ant-table-content,
.ant-table-without-column-header table {
  border-radius: 0;
}
.ant-table-tbody > tr.ant-table-row-selected {
  background: #fafafa;
}
.ant-table-thead > tr > th.ant-table-column-sort {
  background: #eee;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 8px;
  word-break: break-all;
}
.ant-table-thead > tr > th.ant-table-selection-column-custom {
  padding-left: 16px;
  padding-right: 0;
}
.ant-table-thead > tr > th.ant-table-selection-column,
.ant-table-tbody > tr > td.ant-table-selection-column {
  text-align: center;
  min-width: 62px;
  width: 62px;
}
.ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
  text-align: center;
  min-width: 50px;
  width: 50px;
}
.ant-table-header {
  background: #f7f7f7;
  overflow: hidden;
}
.ant-table-header table {
  border-radius: 4px 4px 0 0;
}
.ant-table-loading {
  position: relative;
}
.ant-table-loading .ant-table-body {
  background: #fff;
  opacity: 0.5;
}
.ant-table-loading .ant-table-spin-holder {
  height: 20px;
  line-height: 20px;
  left: 50%;
  top: 50%;
  margin-left: -30px;
  position: absolute;
}
.ant-table-loading .ant-table-with-pagination {
  margin-top: -20px;
}
.ant-table-loading .ant-table-without-pagination {
  margin-top: 10px;
}
.ant-table-middle .ant-table-thead > tr > th:not(.ant-table-selection-column),
.ant-table-middle .ant-table-tbody > tr > td {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-title,
.ant-table-middle .ant-table-footer {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-column-sorter-up:after {
  top: -13px;
  height: 13px;
}
.ant-table-middle .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-middle .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-middle .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 38px;
  top: -13px;
}
.ant-table-small {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
.ant-table-small .ant-table-header > table,
.ant-table-small .ant-table-body > table {
  border: 0;
  padding: 0 8px;
}
.ant-table-small .ant-table-thead > tr > th {
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-small .ant-table-tbody > tr > td {
  padding: 6px 8px;
}
.ant-table-small .ant-table-title,
.ant-table-small .ant-table-footer,
.ant-table-small .ant-table-thead > tr > th:not(.ant-table-selection-column) {
  padding: 10px 8px;
}
.ant-table-small .ant-table-title {
  border-bottom: 1px solid #e9e9e9;
  top: 0;
}
.ant-table-small .ant-table-header {
  background: #fff;
}
.ant-table-small .ant-table-header table {
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-small .ant-table-placeholder,
.ant-table-small .ant-table-row:last-child td {
  border-bottom: 0;
}
.ant-table-small .ant-table-column-sorter-up:after {
  top: -14px;
  height: 13px;
}
.ant-table-small .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-small .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-small .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 39px;
  top: -14px;
}
.ant-table-column-sorter {
  position: relative;
  margin-left: 4px;
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  text-align: center;
}
.ant-table-column-sorter-up,
.ant-table-column-sorter-down {
  line-height: 4px;
  display: block;
  width: 14px;
  cursor: pointer;
}
.ant-table-column-sorter-up:hover .anticon,
.ant-table-column-sorter-down:hover .anticon {
  color: #666;
}
.ant-table-column-sorter-up.on .anticon-caret-up,
.ant-table-column-sorter-down.on .anticon-caret-up,
.ant-table-column-sorter-up.on .anticon-caret-down,
.ant-table-column-sorter-down.on .anticon-caret-down {
  color: #00b8a9;
}
.ant-table-column-sorter-up:after,
.ant-table-column-sorter-down:after {
  position: absolute;
  content: '';
  height: 20px;
  width: 14px;
  left: 0;
}
.ant-table-column-sorter-up:after {
  top: -19px;
}
.ant-table-column-sorter-down:after {
  bottom: -17px;
}
.ant-table-column-sorter .anticon-caret-up,
.ant-table-column-sorter .anticon-caret-down {
  display: inline-block;
  font-size: 14px;
  font-size: 8px \9;
  transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  line-height: 6px;
  height: 6px;
  color: #aaa;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  filter: none;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  font-size: 14px;
}
.ant-table-column-sorter .anticon-caret-up:before,
.ant-table-column-sorter .anticon-caret-down:before {
  -moz-transform-origin: 53% 50%;
  /* fix firefox position */
}
.ant-table-bordered .ant-table-header > table,
.ant-table-bordered .ant-table-body > table,
.ant-table-bordered .ant-table-fixed-left table,
.ant-table-bordered .ant-table-fixed-right table {
  border: 1px solid #e9e9e9;
  border-right: 0;
  border-bottom: 0;
}
.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  border-left: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {
  border-bottom: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {
  border-top: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-placeholder {
  border: 0;
}
.ant-table-bordered .ant-table-thead > tr > th {
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-bordered .ant-table-thead > tr > th,
.ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small {
  border-right: 0;
}
.ant-table-bordered.ant-table-small .ant-table-header > table,
.ant-table-bordered.ant-table-small .ant-table-body > table,
.ant-table-bordered.ant-table-small .ant-table-fixed-left table,
.ant-table-bordered.ant-table-small .ant-table-fixed-right table {
  border: 0;
  padding: 0;
}
.ant-table-bordered.ant-table-small .ant-table-title {
  border: 0;
  border-bottom: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer {
  border: 0;
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer:before {
  display: none;
}
.ant-table-bordered.ant-table-small .ant-table-placeholder {
  border-left: 0;
  border-bottom: 0;
}
.ant-table-placeholder {
  position: relative;
  padding: 16px 8px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  text-align: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-table-placeholder .anticon {
  margin-right: 4px;
}
.ant-table-pagination {
  margin: 16px 0;
  float: right;
}
.ant-table-filter-dropdown {
  min-width: 96px;
  margin-left: -8px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  border: 0;
  box-shadow: none;
  border-radius: 4px 4px 0 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {
  max-height: 400px;
  overflow-x: hidden;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {
  padding: 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-sub {
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title:after {
  color: #00b8a9;
  font-weight: bold;
  text-shadow: 0 0 2px #cff2ef;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item {
  overflow: hidden;
}
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {
  border-radius: 0;
}
.ant-table-filter-dropdown-btns {
  overflow: hidden;
  padding: 7px 8px;
  border-top: 1px solid #e9e9e9;
}
.ant-table-filter-dropdown-link {
  color: #00b8a9;
}
.ant-table-filter-dropdown-link:hover {
  color: #3dc9be;
}
.ant-table-filter-dropdown-link:active {
  color: #009e94;
}
.ant-table-filter-dropdown-link.confirm {
  float: left;
}
.ant-table-filter-dropdown-link.clear {
  float: right;
}
.ant-table-selection-select-all-custom {
  margin-right: 4px !important;
}
.ant-table-selection .anticon-down {
  color: #aaa;
  transition: all .3s;
}
.ant-table-selection-menu {
  min-width: 96px;
  margin-top: 5px;
  margin-left: -30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-selection-menu .ant-action-down {
  color: #aaa;
}
.ant-table-selection-down {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  line-height: 1;
}
.ant-table-selection-down:hover .anticon-down {
  color: #666;
}
.ant-table-row-expand-icon {
  cursor: pointer;
  display: inline-block;
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 14px;
  border: 1px solid #e9e9e9;
  user-select: none;
  background: #fff;
}
.ant-table-row-expanded:after {
  content: '-';
}
.ant-table-row-collapsed:after {
  content: '+';
}
.ant-table-row-spaced {
  visibility: hidden;
}
.ant-table-row-spaced:after {
  content: '.';
}
.ant-table-row[class*="ant-table-row-level-0"] .ant-table-selection-column > span {
  display: inline-block;
}
tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #fbfbfb;
}
.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 8px;
}
.ant-table-scroll {
  overflow: auto;
  overflow-x: hidden;
}
.ant-table-scroll table {
  width: auto;
  min-width: 100%;
}
.ant-table-body-inner {
  height: 100%;
}
.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  position: relative;
  background: #fff;
}
.ant-table-fixed-header .ant-table-body-inner {
  overflow: scroll;
}
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow: scroll;
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.ant-table-fixed-header.ant-table-empty .ant-table-scroll .ant-table-body {
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.ant-table-fixed-left,
.ant-table-fixed-right {
  position: absolute;
  top: 0;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  border-radius: 0;
}
.ant-table-fixed-left table,
.ant-table-fixed-right table {
  width: auto;
  background: #fff;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,
.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {
  border-radius: 0;
}
.ant-table-fixed-left {
  left: 0;
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-left .ant-table-header {
  overflow-y: hidden;
}
.ant-table-fixed-left .ant-table-body-inner {
  margin-right: -20px;
  padding-right: 20px;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {
  padding-right: 0;
}
.ant-table-fixed-left,
.ant-table-fixed-left table {
  border-radius: 4px 0 0 0;
}
.ant-table-fixed-right {
  right: 0;
  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-right,
.ant-table-fixed-right table {
  border-radius: 0 4px 0 0;
}
.ant-table-fixed-right .ant-table-expanded-row {
  color: transparent;
  pointer-events: none;
}
.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {
  box-shadow: none;
}
.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {
  box-shadow: none;
}
`,
    `.nz-resize-container {
  position: relative;
}
.nz-resize-y {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 102%;
  background: transparent;
  cursor: col-resize;
}
.nz-resizing th,
.nz-resizing td {
  user-select: none;
}
`
  ]
})
export class NzTableComponent implements AfterViewInit, OnInit {
  private _bordered = false;
  private _customNoResult = false;
  private _isPageIndexReset = true;
  private _isPagination = true;
  private _loading = false;
  private _showSizeChanger = false;
  private _showQuickJumper = false;
  private _showTotal = false;
  private _showFooter = false;
  private _showTitle = false;

  /** public data for ngFor tr */
  // TODO: the data cannot be type-checked in current design
  /* tslint:disable-next-line:no-any */
  data: any[] = [];
  _scroll: { y: number };
  _el: HTMLElement;
  _headerBottomStyle;
  _current = 1;
  _total: number;
  _pageSize = 10;
  /* tslint:disable-next-line:no-any */
  _dataSet: any[] = [];
  _isInit = false;
  _isAjax = false;
  ths = [];
  @Output() nzPageSizeChange: EventEmitter<number> = new EventEmitter();
  @Output() nzPageIndexChange: EventEmitter<number> = new EventEmitter();
  /* tslint:disable-next-line:no-any */
  @Output() nzDataChange: EventEmitter<any[]> = new EventEmitter();
  @Output() nzPageIndexChangeClick: EventEmitter<number> = new EventEmitter();
  @Input() nzSize: string;

  @Input()
  set nzBordered(value: boolean) {
    this._bordered = toBoolean(value);
  }

  get nzBordered(): boolean {
    return this._bordered;
  }

  @Input()
  set nzCustomNoResult(value: boolean) {
    this._customNoResult = toBoolean(value);
  }

  get nzCustomNoResult(): boolean {
    return this._customNoResult;
  }

  @Input()
  set nzIsPagination(value: boolean) {
    this._isPagination = toBoolean(value);
  }

  get nzIsPagination(): boolean {
    return this._isPagination;
  }

  @Input()
  set nzLoading(value: boolean) {
    this._loading = toBoolean(value);
  }

  get nzLoading(): boolean {
    return this._loading;
  }

  @Input()
  set nzShowSizeChanger(value: boolean) {
    this._showSizeChanger = toBoolean(value);
  }

  get nzShowSizeChanger(): boolean {
    return this._showSizeChanger;
  }

  @Input()
  set nzShowQuickJumper(value: boolean) {
    this._showQuickJumper = toBoolean(value);
  }

  get nzShowQuickJumper(): boolean {
    return this._showQuickJumper;
  }

  @Input()
  set nzShowTotal(value: boolean) {
    this._showTotal = toBoolean(value);
  }

  get nzShowTotal(): boolean {
    return this._showTotal;
  }

  @Input()
  set nzShowFooter(value: boolean) {
    this._showFooter = toBoolean(value);
  }

  get nzShowFooter(): boolean {
    return this._showFooter;
  }

  @Input()
  set nzShowTitle(value: boolean) {
    this._showTitle = toBoolean(value);
  }

  get nzShowTitle(): boolean {
    return this._showTitle;
  }

  @Input()
  set nzIsPageIndexReset(value: boolean) {
    this._isPageIndexReset = toBoolean(value);
  }

  get nzIsPageIndexReset(): boolean {
    return this._isPageIndexReset;
  }

  /** page size changer select values */
  @Input() nzPageSizeSelectorValues = [10, 20, 30, 40, 50];
  @ContentChild('nzFixedHeader') fixedHeader: TemplateRef<void>;

  @ContentChildren(NzThDirective, { descendants: true })
  set setThs(value: QueryList<NzThDirective>) {
    this.ths = value.toArray();
  }

  @Input()
  set nzScroll(value: { y: number }) {
    this._scroll = value;
    this._cd.detectChanges();
  }

  get nzScroll(): { y: number } {
    return this._scroll;
  }

  /** async data */
  @Input()
  /* tslint:disable-next-line:no-any */
  set nzAjaxData(data: any[]) {
    this._isAjax = true;
    this.data = data;
  }

  /* tslint:disable-next-line:no-any */
  get nzAjaxData(): any[] {
    return this.data;
  }

  /** sync data */
  @Input()
  /* tslint:disable-next-line:no-any */
  set nzDataSource(value: any[]) {
    this._dataSet = value;
    this.nzTotal = this._dataSet.length;
    this._generateData(true);
  }

  /* tslint:disable-next-line:no-any */
  get nzDataSource(): any[] {
    return this._dataSet;
  }

  @Input()
  set nzPageIndex(value: number) {
    if (this._current === value) {
      return;
    }
    this._current = value;
    this._generateData();
    this.nzPageIndexChange.emit(this.nzPageIndex);
  }

  get nzPageIndex(): number {
    return this._current;
  }

  pageChangeClick(value: number): void {
    this.nzPageIndexChangeClick.emit(value);
  }

  @Input()
  set nzPageSize(value: number) {
    if (this._pageSize === value) {
      return;
    }
    this._pageSize = value;
    this._generateData();
    if (this._isInit) {
      this.nzPageSizeChange.emit(value);
    }
  }

  get nzPageSize(): number {
    return this._pageSize;
  }

  @Input()
  set nzTotal(value: number) {
    if (this._total === value) {
      return;
    }
    this._total = value;
  }

  get nzTotal(): number {
    return this._total;
  }

  _generateData(forceRefresh: boolean = false): void {
    if (!this._isAjax) {
      if (this.nzIsPagination) {
        if (forceRefresh) {
          if (this.nzIsPageIndexReset) {
            this.nzPageIndex = 1;
          } else {
            const maxPageIndex = Math.ceil(this._dataSet.length / this.nzPageSize);
            this.nzPageIndex = !this.nzPageIndex ? 1 : (this.nzPageIndex > maxPageIndex ? maxPageIndex : this.nzPageIndex);
          }
        }
        this.data = this._dataSet.slice((this.nzPageIndex - 1) * this.nzPageSize, this.nzPageIndex * this.nzPageSize);
      } else {
        this.data = this._dataSet;
      }
      this.nzDataChange.emit(this.data);
    }
  }

  ngOnInit(): void {
    const scrollbarWidth = measureScrollbar();
    this._headerBottomStyle = {
      marginBottom : `-${scrollbarWidth}px`,
      paddingBottom: `0px`
    };
  }

  constructor(private _elementRef: ElementRef, private _cd: ChangeDetectorRef) {
    this._el = this._elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this._isInit = true;
  }
}
